module.exports = __webpack_public_path__ + "static/media/pro-miikka-salminen.d2f57e33.webp";